import {
  createBrowserHistory,
  createMemoryHistory,
  createRouter as createTanStackRouter,
} from '@tanstack/react-router';
import { attachPageViews, attachVibeRouteSync, getInitialRoute, isInIframe } from '@lib/vibe-route-sync';
import { routeTree } from './routeTree.gen';

// Start resolves this module as the router entry and expects a `getRouter` export.
// The route tree is generated by the tanstackStart vite plugin from src/routes.ts (virtual routes):
// __root lives in read-only src/routes/, the agent's pages in the writable src/generated/routes/.
export function getRouter() {
  // Pick history for where the app runs:
  // - monday iframe: in-memory history seeded from the host's ?vibe-route= param. The static CDN
  //   bundle only serves '/', so real browser paths would 404 on refresh/deep-link; memory history
  //   keeps the URL at '/' and we sync the logical route to the host via postMessage.
  // - standalone browser (dev/direct): normal browser history.
  // - prerender/server (no window): memory history at '/'.
  const history = isInIframe()
    ? createMemoryHistory({ initialEntries: [getInitialRoute()] })
    : typeof window !== 'undefined'
      ? createBrowserHistory()
      : createMemoryHistory({ initialEntries: ['/'] });

  const router = createTanStackRouter({
    routeTree,
    history,
    scrollRestoration: true,
    defaultPreload: 'intent',
  });

  attachVibeRouteSync(router);
  attachPageViews(router);

  return router;
}

declare module '@tanstack/react-router' {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
  interface StaticDataRouteOption {
    title?: string;
  }
}
